const CATEGORY = 'category';
const AUTHOR = 'author';
const PSEUDO_CATEGORY = 'pseudo-category';
const INFINITE_LIST_API_URL = 'ajax/pagination/';
const INGREDIENT = 'ingredient';

export {CATEGORY, PSEUDO_CATEGORY, AUTHOR, INGREDIENT, INFINITE_LIST_API_URL};
